import axios from 'axios'
const config = { apiUrl: process.env.REACT_APP_API_URL }
const authHeader = require('./authHeader')

// Search users by email to choose a group admin. groupId is the "all users"
// group whose admin permissions gate this feature.
function searchUsers (groupId, email, signal) {
  if (groupId && typeof groupId === 'string' && email) {
    const options = {
      headers: authHeader.authHeader(),
      params: { email },
      signal
    }
    return axios.get(`${config.apiUrl}group/${groupId}/createGroup/searchUsers`, options)
      .then((response) => response.data.users)
  } else {
    return Promise.resolve([])
  }
}

// Search existing groups by name to pick one to add an admin to.
function searchGroups (groupId, name, signal) {
  if (groupId && typeof groupId === 'string' && name) {
    const options = {
      headers: authHeader.authHeader(),
      params: { name },
      signal
    }
    return axios.get(`${config.apiUrl}group/${groupId}/searchGroups`, options)
      .then((response) => response.data.groups)
  } else {
    return Promise.resolve([])
  }
}

function createGroup (groupId, { name, joinCode, adminUserId, permissions }) {
  if (groupId && typeof groupId === 'string') {
    const options = {
      headers: authHeader.authHeader()
    }
    const payload = { name, joinCode, adminUserId, permissions }
    return axios.post(`${config.apiUrl}group/${groupId}/createGroup`, payload, options)
      .then((response) => response.data)
  } else {
    return Promise.reject(new Error('Invalid Group Id'))
  }
}

// Add (or update) an admin on an existing group.
function addAdmin (groupId, { targetGroupId, adminUserId, permissions }) {
  if (groupId && typeof groupId === 'string') {
    const options = {
      headers: authHeader.authHeader()
    }
    const payload = { targetGroupId, adminUserId, permissions }
    return axios.post(`${config.apiUrl}group/${groupId}/addAdmin`, payload, options)
      .then((response) => response.data)
  } else {
    return Promise.reject(new Error('Invalid Group Id'))
  }
}

export const groupCreationService = {
  searchUsers,
  searchGroups,
  createGroup,
  addAdmin
}
